export default __webpack_public_path__ + "static/media/io.0838e35f.svg";